module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Mastery",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16.2790698,30.4716981 L35,36.9622642 L53.7209302,30.4716981 L53.7209302,47.509434 L35,54 L16.2790698,47.509434 L16.2790698,30.4716981 Z M34.9710399,10.9802545 L69.9341817,23.2264151 L35.0105309,35.3593681 L9.80455984,26.5398771 L9.8293111,41.8196577 L7.39139974,41.8157086 L7.36525374,25.6749118 L0.0473892058,23.1132075 L34.9710399,10.9802545 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25397ce4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/mastery.vue
// module id = 603
// module chunks = 1